const llamarServicioGet = async (ruta) => {
  const resp = await fetch(ruta);
  const data = await resp.json();
  return data.response;
};

export default llamarServicioGet;
